export default __webpack_public_path__ + "static/media/telephone-call.338d13d0.png";